import styled, { createGlobalStyle } from 'styled-components';
import { Select, DatePicker, Table } from 'antd';
import * as GlobalStyled from 'components/Layouts/Layout.styled';
import { IToken } from 'store/ducks/globalTypes';

export const EntitySelect = styled(Select)`
  width: 120px;
  margin-right: 8px;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 120px;
  margin-right: 8px;
`;

export const StyledHorizontalFilterBar = styled(
  GlobalStyled.HorizontalFilterBar
)`
  margin-left: 5px;
`;

export const StyledTable = styled(Table)`
  margin-top: 16px;
`;

export const groupOrgHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'middle',
  height: '56px',
  position: 'relative'
};

export const groupOrgDateHeaderStyle = {
  paddingTop: '0px'
};

export const groupOrgStartDateCellStyle = {
  borderRight: '1px solid #d9d9d9'
};

export const GroupOrganizationTableWrapper = styled.div`
  .ant-table-thead > tr:nth-child(2) > th {
    padding: 0;
    height: 0;
    line-height: 0;
    border: 0;
  }

  .ant-table-thead > tr:nth-child(2) > th::before {
    display: none;
    content: none;
  }
  .ant-table-thead > tr:nth-child(2) > th::after {
    display: none;
    content: none;
  }
`;

export const GlobalDatePickerStyle = createGlobalStyle<IToken>`
  .white-bg-datepicker .ant-picker-panel-container {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-panel {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-date-panel,
  .white-bg-datepicker .ant-picker-body {
    background: #ffffff !important;
  }
`;
